import Image from "next/image";
import Link from "next/link";
import DarkMode from "../mode/DarkMode";
import Logo from "./../../public/images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { isExpired } from "../../utils/helpers";
import { useEffect, useState } from "react";
import { Spin } from "antd";
import LoadingOutlined from "@ant-design/icons/LoadingOutlined";
import { useRouter } from "next/router";
import { loadUser } from "../../actions/userAction";
import { creditCounts } from "../../actions/orderAction";

export default function Logotop({ logoUrl }) {
  const [imageUrl, setImageUrl] = useState('/images/logo.png');

  useEffect(() => {
    // Update imageUrl if logoUrl is provided and not "undefined"
    if (logoUrl !== undefined && logoUrl !== "undefined") {
      setImageUrl(logoUrl);
    }
  }, [logoUrl]);
  const { user } = useSelector((state) => state.user);

  const router = useRouter();
  const dispatch = useDispatch();
  const { pathname } = router;
  const [isCandidate, setIsCandidate] = useState(false);

  useEffect(() => {
    if (pathname.includes("candidate")) {
      setIsCandidate(true);


    } else {
      setIsCandidate(false);
    }
  }, []);

  const data = useSelector((state) => state?.creditsCount?.orders?.creditsData); // Assuming that the user data is stored in the 'user' property of the Redux store
  const isValid = !isExpired(data?.planExpiryDate);
  const [showCustomLogo, setCustomLogo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showNavBar, setShowNavbar] = useState(true);
  useEffect(() => {
    // const target = ((user?.whiteLabel === 1) && (isValid) && (data?.currentPlan === "Professional" || data?.currentPlan === "Free-Trial"));
    // console.log("Show Custom Logo", target, user?.whiteLabel === 1, isValid, data?.currentPlan === "Professional" || data?.currentPlan === "Free-Trial")
    if (user) {
      const { hasValidWhiteLabel } = user;
      setCustomLogo(hasValidWhiteLabel);
    }
  }, [data, isValid, user]);

  return (
    <>
      {!showNavBar && (
        <div className="p-4">
          <Spin indicator={<LoadingOutlined />} />
        </div>
      )}
      {showNavBar && (
        <header className="js-page-header fixed top-0 z-20 w-full transition-colors bg-white h-16 ">
          <div className="flex items-center h-full">
            <a>
              <div>
                {!showCustomLogo && !loading && (
                  <img
                    height={50}
                    width={185}
                    className="p-6 h-20 w-auto"
                    src={imageUrl}
                    alt="SynthiaHire 2"
                  />
                )}
                {showCustomLogo && (
                  <img
                    src={user?.logoURL}
                    height={50}
                    width={185}
                    className="p-6 h-20 w-auto"
                  />
                )}
              </div>
            </a>
          </div>
        </header>
      )}
    </>
  );
}
